export default {
  conference: [
    {
      // 第一个数据格式与其他数据格式不同
      // 1.1 图片为大图
      'id': 12,
      'videoUrl': 'http://static.geekbang.org/qconsh2017/qconsh2017-video.mp4',
      'urllink': 'https://2018.qconshanghai.com?utm_source=geekbang&utm_medium=banner',
      'pc_imgUrl': '',
      'm_imgUrl': 'https://static001.geekbang.org/resource/image/98/3b/98bc3cca1fdf26e3dd211f835326a43b.jpg'
    },
    {
      'id': 4,
      'urllink': 'https://cnutcon2018.geekbang.org/?utm_source=geekbang&utm_medium=banner',
      'imgUrl': 'https://static001.geekbang.org/resource/image/6f/07/6feb6cc5583c27b5c6c0e282108f2007.png',
      'title': 'CNUTCon全球运维技术大会',
      'dateAndLoc': '2018-11-16 / 中国 / 上海'
    },
    {
      'id': 3,
      'urllink': 'http://www.archsummit.com/?utm_source=geekbang&utm_medium=banner',
      'imgUrl': require('../../static/img/conference/AS.jpg'),
      'title': 'ArchSummit 全球架构师峰会',
      'dateAndLoc': '2018-12-07 / 中国 / 北京'
    },
    {
      'id': 6,
      'urllink': 'https://aicon2018.geekbang.org/?utm_source=geekbang&utm_medium=banner',
      'imgUrl': 'https://static001.geekbang.org/resource/image/fd/53/fde96af533d25feac4e36507567eae53.png',
      'title': 'AICon全球人工智能与机器学习大会',
      'dateAndLoc': '2018-12-20 / 中国 / 北京'
    },
    {
      'id': 6,
      'urllink': 'http://bccon.geekbang.org/?utm_source=geekbang&utm_medium=banner',
      'imgUrl': require('../../static/img/conference/BCCon.jpg'),
      'title': 'BCCon 全球区块链生态技术大会',
      'dateAndLoc': '2018-8-18 / 中国 / 北京'
    },
    {
      'id': 5,
      'urllink': 'http://gmtc.geekbang.org/',
      'imgUrl': require('../../static/img/conference/GMTC.jpg'),
      'title': 'GMTC 全球移动技术大会',
      'dateAndLoc': '2018-06-21 / 中国 / 北京'
    },
    {
      'id': 4,
      'urllink': 'http://gtlc.geekbang.org',
      'imgUrl': require('../../static/img/conference/GTLC.jpg'),
      'title': '全球技术领导力峰会 GTLC',
      'dateAndLoc': '2018-06-08 / 中国 / 北京'
    },
    {
      'id': 2,
      'urllink': 'http://www.cnutcon.com/?utm_source=geekbang&utm_campaign=8&utm_medium=banner',
      'imgUrl': require('../../static/img/conference/CNUTCon.jpg'),
      'title': 'CNUTCon 全球运维技术大会',
      'dateAndLoc': '2018-11-16 / 中国 / 上海'
    },
    {
      'id': 8,
      'urllink': 'https://aicon.geekbang.org/',
      'imgUrl': 'https://static001.geekbang.org/static/www/img/m_conference.c7604f8.jpg',
      'title': 'AICon 全球人工智能与机器学习技术大会',
      'dateAndLoc': '2018-12-20 / 中国 / 北京'
    },
    {
      'id': 7,
      'urllink': 'http://gplus.geekbang.org/',
      'imgUrl': require('../../static/img/conference/G＋.jpg'),
      'title': 'G+ 全球技术价值峰会',
      'dateAndLoc': '2017-04-19 / 中国 / 北京'
    },
    {
      'id': 6,
      'urllink': 'http://www.chinatechday.com/2017eur',
      'imgUrl': require('../../static/img/conference/CTD.jpg'),
      'title': '中国技术开放日',
      'dateAndLoc': '2018-06-08 / 欧洲'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/util/conference.js